import common from './modules/common';
import menu from './modules/menu';
import site from './modules/site';
import choiceSet from './modules/choiceSet';
import choice from './modules/choice';
import category from './modules/category';
import template from './modules/template';
import item from './modules/item';
import login from './modules/login';
import companyConfiguration from './modules/companyConfiguration';
import siteConfiguration from './modules/siteConfiguration';
import reports from './modules/reports';
import modifier from './modules/modifier';
import homePage from './modules/homePage';
import user from './modules/user';

export {
    common,
    menu,
    site,
    choice,
    choiceSet,
    category,
    template,
    item,
    login,
    companyConfiguration,
    siteConfiguration,
    reports,
    modifier,
    homePage,
    user
}



// WEBPACK FOOTER //
// ./src/api/index.js